import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Stack } from "react-bootstrap";

import { SupportSection } from "./support_section";
import { CreateSupportTicket } from "./create_support_ticket";
import { SupportTicketsList } from "./support_tickets_list";
import { fetchSupportTicketsRequest } from "@/services";
import { SupportHeader } from "./support_header";

export function LoanSupportTickets() {
  const { loanUUID: loanId } = useParams();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadTickets = async () => {
    setLoading(true);

    const res = await fetchSupportTicketsRequest(loanId);


    const ticketsData =
      Array.isArray(res) ? res :
      Array.isArray(res?.data) ? res.data :
      Array.isArray(res?.results) ? res.results :
      [];

    setTickets(
      ticketsData.filter(t => String(t.loan) === String(loanId))
    );

    setLoading(false);
  };

  useEffect(() => {
    loadTickets();
  }, [loanId]);

  return (
    <Container fluid>
      <SupportHeader
        breadcrumb="Dashboard > Open a ticket"
        title="Open a ticket"
      />

      <Row className="g-4">
        {/* LEFT SIDE */}
        <Col xs={12} md={7}>
          <Stack gap={4}>
            <SupportSection />
            <CreateSupportTicket onSuccess={loadTickets} />
          </Stack>
        </Col>

        {/* RIGHT SIDE */}
        <Col xs={12} md={5}>
          <SupportTicketsList
            tickets={tickets}
            loading={loading}
          />
        </Col>
      </Row>
    </Container>
  );
}
